import classnames from "classnames";
import { usePricingExplorer } from "./PricingExplorerContext";
import styles from "./pricing-explorer.module.scss";

export const BillingToggle = () => {
  const { billingPeriod, setBillingPeriod } = usePricingExplorer();

  return (
    <div
      className={styles.billingToggle}
      role="radiogroup"
      aria-label="Billing period"
    >
      <button
        type="button"
        role="radio"
        aria-checked={billingPeriod === "monthly"}
        className={classnames(styles.billingOption, {
          [styles.billingOptionActive]: billingPeriod === "monthly",
        })}
        onClick={() => setBillingPeriod("monthly")}
      >
        Monthly
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={billingPeriod === "yearly"}
        className={classnames(styles.billingOption, {
          [styles.billingOptionActive]: billingPeriod === "yearly",
        })}
        onClick={() => setBillingPeriod("yearly")}
      >
        Yearly (save up to 17%)
      </button>
    </div>
  );
};
